/* eslint-disable @typescript-eslint/no-unused-vars */
// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Actions, ofType } from '@ngrx/effects';
// NGRX
import { select, Store } from '@ngrx/store';
// RxJS
import { Observable, Subject, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import {
  LayoutUtilsService,
  MessageType,
} from '../../../../../../core/_base/crud';
// AppState
import { AppState } from '../../../../../../core/reducers';
import {
  GCActionFail,
  GCActionSuccess,
  GConfig,
  GConfigActionTypes,
  GConfigBulkUpdate,
  selectGConfigById,
} from '../../../../../../core/ronex';

@Component({
  selector: 'kt-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss'],
})
export class LegalComponent implements OnInit, OnDestroy {
  @Input() saveEvent: Observable<void>;

  public Editor = ClassicEditor;

  gdpr: GConfig = new GConfig();
  ox: GConfig = new GConfig();

  tb = [
    'heading',
    '|',
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    'blockQuote',
  ];

  serverError: Subject<any>;

  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<AppState>,
    private layoutUtilsService: LayoutUtilsService,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.serverError = new Subject();
    this.serverError.next(false);

    const ss = this.saveEvent.subscribe(() => this.save());
    this.subscriptions.push(ss);

    this.fetchDataFromStore();

    const sss = this.actions$
      .pipe(
        ofType<GCActionSuccess>(GConfigActionTypes.GCActionSuccess),
        tap(({ payload }) => {
          this.layoutUtilsService.showActionNotification(
            payload.result,
            MessageType.Update,
            5000,
            true,
            true
          );
        })
      )
      .subscribe();
    this.subscriptions.push(sss);

    const sf = this.actions$
      .pipe(
        ofType<GCActionFail>(GConfigActionTypes.GCActionFail),
        tap(({ payload }) => {
          if (
            // eslint-disable-next-line no-prototype-builtins
            payload.result.hasOwnProperty('error') &&
            // eslint-disable-next-line no-prototype-builtins
            payload.result.error.hasOwnProperty('detail')
          ) {
            this.serverError.next(payload.result.error.detail);
          } else {
            this.serverError.next(
              'Συνέβη ένα σφάλμα με την αποθήκευση των δεδομένων. Παρακαλώ ξαναπροσπαθήστε.'
            );
          }
        })
      )
      .subscribe();
    this.subscriptions.push(sf);
  }

  fetchDataFromStore() {
    this.store
      .pipe(
        select(selectGConfigById('general__gdpr')),
        take(1),
        tap(res => (this.gdpr = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('general__ox')),
        take(1),
        tap(res => (this.ox = { ...res }))
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  save() {
    /* const tmp : GConfig = new GConfig()
        tmp.identifier = this.gdpr.identifier;
        tmp.value = this.gdpr.value;
        this.store.dispatch( new GConfigUpdate( { gconfig : tmp } ));*/
    const buo: { [key: string]: any } = {};
    buo[this.gdpr.identifier] = this.gdpr.value;
    buo[this.ox.identifier] = this.ox.value;
    this.store.dispatch(new GConfigBulkUpdate({ values: buo }));
  }

  onAlertClose($event) {
    this.serverError.next(false);
  }
}
